import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "group relative inline-block w-full"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "text-surface-600"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  const _component_Menu = _resolveComponent("Menu");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Button, {
    icon: "fa-regular fa-language",
    variant: "text",
    label: _ctx.$tf('profile.language.hu|Nyelv'),
    severity: "contrast",
    "aria-haspopup": "true",
    "aria-controls": "icon_menu",
    onClick: $options.toggleMenu,
    size: "small",
    pt: {
      root: {
        class: 'hover:!bg-surface-100 w-full !justify-start'
      },
      icon: {
        class: '!text-surface-700'
      },
      label: {
        class: '!text-surface-600'
      }
    }
  }, null, 8, ["label", "onClick"]), _createVNode(_component_Menu, {
    ref: "menu",
    model: $options.languages,
    popup: "",
    class: "z-50 text-xs"
  }, {
    item: _withCtx(({
      item
    }) => [_createElementVNode("div", {
      class: "p-2 cursor-pointer hover:!bg-surface-200 focus:!bg-surface-200 selected:!bg-surface-200 rounded-sm",
      onClick: $event => $options.changeLanguage(item.value)
    }, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)], 8, _hoisted_2)]),
    _: 1
  }, 8, ["model"])]);
}